import { blogPlugin } from '@next-adapter/plugins/blog/plugin.js'
import { portfolioPlugin } from '@next-adapter/plugins/portfolio/plugin.js'
import type { BetterstartPluginDefinition, BetterstartPluginId } from '@plugin-engine/types.js'

export const pluginRegistry: Record<string, BetterstartPluginDefinition> = {
  blog: blogPlugin,
  portfolio: portfolioPlugin
}

export function listPluginDefinitions(): BetterstartPluginDefinition[] {
  return Object.values(pluginRegistry)
}

export function getPluginDefinition(pluginId: BetterstartPluginId): BetterstartPluginDefinition {
  const definition = pluginRegistry[pluginId]
  if (!definition) {
    throw new Error(formatUnknownPluginMessage([pluginId]))
  }
  return definition
}

export function isPluginId(value: string): value is BetterstartPluginId {
  return value in pluginRegistry
}

export function formatUnknownPluginMessage(pluginIds: string[]): string {
  return `Unknown plugin(s): ${pluginIds.join(', ')}. Available for next: ${Object.keys(pluginRegistry).join(', ')}`
}
